export const text =
`
I do software consulting
`
